import deviceHook from './deviceHook'
import svgHook from './svgHook'

export  const useDeviceHook = deviceHook

export const useSvgHook = svgHook;
